import React from "react";
import { Button } from "./button";

export const PublishConfirmModal = ({
  open,
  onClose,
  onConfirm,
  isPublished,
}) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
        <h3 className="text-lg font-semibold mb-4">
          {isPublished ? "Unpublish" : "Publish"} Collection
        </h3>
        <p>
          Are you sure you want to {isPublished ? "unpublish" : "publish"} this
          collection?
        </p>
        <div className="flex justify-end gap-2 mt-6">
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button
            type="button"
            className="bg-blue-500 text-white"
            onClick={onConfirm}
          >
            {isPublished ? "Unpublish" : "Publish"}
          </Button>
        </div>
      </div>
    </div>
  );
};
